module.exports = __webpack_public_path__ + "static/media/nps-passive.5f477aea.svg";